<template lang='pug'>
	.container-fluid.p-0.push-wrapper
		.container
			.row
				.col
					.row
						.col-12.my-header.font-weight-bold
							| Настройки

		.container.mt-5
			.row(v-if='loading') 
				.loader_holder
					object(type="image/svg+xml" data="/assets/loaders/infinity.svg")
			.white_block(v-for="chat of chats" v-if='!loading' :class="{turnedoff: !chat.enabled}")
				.row
					.col
						h4 Основные настройки
						.inputModule
							input-module(type="text" title="Название чата" v-model="chat.name")
						.inputModule
							input-module(type="checkbox" v-model="chat.enabled" label="Включить чат")
						.inputModule
							input-module(type="text" title="Приветственный текст" v-model="chat.welcome_message" emojis="true")
						h4 Интеграция с личным кабинетом гостя
						.inputModule
							input-module(type="text" title="API для получения пользовательских данных" v-model="chat.user_info_fetch_url" placeholder="https://site.com/api/getUser" about="Ответ должен быть в формате JSON. Запрос идёт с аутентификационными данными гостя.")
						.inputModule
							input-module(type="select" title="Где в браузере хранится токен аутентификации, когда гость залогинен" v-model="chat.tokenStorage" :values="[{key: 'localStorage', value: 'В LocalStorage'}, {key: 'cookie', value: 'В Cookie'}]" about="Чтобы проверить авторизацию гостя сайта")
						.inputModule
							input-module(type="text" title="Как в браузере называется токен аутентификации, когда гость залогинен" v-model="chat.tokenKey" placeholder="site_token")
						h4 Интеграция на сайт
						.inputModule
							input-module(type="chatconnect-htmlcode" title="Код для сайта" v-model="chat.chat_key")
						button.styled(@click="saveChat(chat)") Сохранить настройки чата
			button.styled.createchatbutton(@click="createChat()" :disabled="creatingChat" v-if='!loading') Создайте новый чат

</template>
<script>
import { Tooltip } from "element-ui";
import moment from "moment";
import apiDriver from '../../apiDriver';

export default {
	components: {
		[Tooltip.name]: Tooltip
	},

	data() {
		return {
			chats: [],
			creatingChat: false,
			loading: true
		};
	},

	computed: {},

	mounted() {
		this.getChats();
	},

	methods: {
		async getChats(){
			let x = (await apiDriver.services.api.get("chatconnect", 'chats')).data.chats;
			this.chats = x;
			this.loading = false;
			// console.log(x[0])
		},
		async saveChat(chat){
			this.$toast.success('Настройки чата успешно сохранены!');
			let chat_proto = JSON.parse(JSON.stringify(chat));
			delete chat_proto.loading;
			let x = (await apiDriver.services.api.post("chatconnect", "chat", chat_proto)).data;
		},
		async createChat(){
			this.creatingChat = true;
			let x = (await apiDriver.services.api.post("chatconnect", 'createChat')).data.chat;
			this.chats.push(x);
		}
	}
};
</script>
<style scoped lang="stylus">
	button.styled {
		margin-bottom: 5px;
		border: 1px solid #6c68cb;
		padding: 10px 15px;
		border-radius: 4px;
		color: #464384;
		cursor: pointer;
		background: white;

		&:hover {
			background: #6c68cb;
			color: white;
		}

		&[disabled] {
			border-color: #ddd;
			color: #ddd;
			cursor: default;
			background: white;
		}

		&:last-child {
			margin-bottom: 0;
		}
	}

	div{cursor: default;}
	.my-header{font-size: 26pt;}
	.header-pre-push{font-size: 1.5rem;}
	.header-push{font-size: 1.5rem;color: black}
	h4, .h4 {
		font-size: 15pt;
		line-height: 1.45em;
		margin-top: 10px;
	}

	.inputModule{
		margin-bottom 10px;
	}

	.createchatbutton{
		margin-top 20px;
	}

	.turnedoff{
		opacity: 0.5;
		&:hover{
			opacity 1;
		}
	}

</style>
